// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Raleway" !important;
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
  margin: 0;
}

.activesection1 {
  padding-top: 0px !important;
}

.activesection2 {
  padding-top: 280px !important;
}

.main-container {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.scroll-outer {
  height: 100%;
}

.card-container {
  height: 100%;
  background: #2196f3;
}

.card-container h3 {
  padding: 25px;
}

.scroll-container {
  width: 100%;
  width: calc(100% - 0px);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  position: fixed;
  top: 120px;
  z-index: 1000;
  background: #fff;
}

.scroll-container:hover {
  opacity: 1;
}

.step-section {
  display: flex;
  flex-direction: row;
  background-color: cream;
  justify-content: flex-start;
}

.vertical-nav {
  position: relative;
}

.step-section .circle {
  background-color: white;
  border: 4px solid red;
  border-radius: 100%;
  width: 12px;
  height: 12px;
  display: inline-block;
}

.step-section.completed .circle {
  visibility: visible;
  border-color: rgb(0, 0, 0);
}

.step-section.active .circle {
  visibility: visible;
  border-color: rgb(0, 0, 0);
}

.step-section.empty .circle {
  visibility: hidden;
}

.about-parallax-page {
  font-family: "Raleway" !important;
}
.about-parallax-page nav {
  position: sticky;
  top: 79px;
  z-index: 10;
  width: 100%;
}
.about-parallax-page .top-nav {
  margin: 0;
  padding: 0;
  display: flex;
  height: 60px;
  background: #fff;
  list-style-type: none;
  justify-content: center;
  align-items: center;
}
.about-parallax-page .top-nav .nav-items .nav-items-link {
  color: #212427;
  padding: 15px;
  font-family: "Raleway";
  font-size: 18px;
  cursor: pointer;
}
.about-parallax-page .top-nav .nav-items.active .nav-items-link {
  color: #428bca;
  border-bottom: 3px solid;
}
.about-parallax-page .inner-content {
  z-index: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.about-parallax-page section {
  position: relative;
  padding-bottom: 50px;
  padding: 5% 10%;
}
.about-parallax-page section p {
  font-size: 16px !important;
}
.about-parallax-page section p.panel-left {
  padding-left: 15%;
}
.about-parallax-page section p.panel-right {
  padding-right: 15%;
}
.about-parallax-page section .img-div-right {
  height: 24vw;
  width: 38vw;
  margin-right: -10vw;
  transition: all 0.8s linear;
}
.about-parallax-page section .img-div-right img {
  display: block;
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
  box-shadow: 1px 4px 6px 0px rgba(0, 0, 0, 0.4117647059);
  transition: all 0.8s linear;
}
.about-parallax-page section .img-div-right:hover img {
  transform: scale(1.1);
  box-shadow: 8px 8px 19px rgba(0, 0, 0, 0.4509803922);
}
.about-parallax-page section .img-div-left {
  height: 24vw;
  width: 38vw;
  margin-right: -10vw;
  transition: all 0.8s linear;
}
.about-parallax-page section .img-div-left img {
  display: block;
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
  box-shadow: 1px 4px 6px 0px rgba(0, 0, 0, 0.4117647059);
  transition: all 0.8s linear;
}
.about-parallax-page section .img-div-left:hover img {
  transform: scale(1.1);
  box-shadow: 8px 8px 19px rgba(0, 0, 0, 0.4509803922);
}
.about-parallax-page section::before {
  content: "";
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  width: 100%;
  height: 100vh;
  z-index: 1;
  position: absolute;
  left: 0%;
  top: 0;
  filter: blur(3px) brightness(0.4);
}
.about-parallax-page section.section-1 {
  padding: 0px 10% !important;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100vh;
  height: 89vh;
}
.about-parallax-page section.section-1::before {
  background-image: url(/assets/images/mob1.jpg);
  height: 100%;
  top: 0px;
}
.about-parallax-page section.section-1 .pra-content h2 {
  font-size: 60px !important;
  line-height: 93px;
  background: -webkit-linear-gradient(#eee, rgb(25, 139, 173));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}
.about-parallax-page section.sectionextra {
  background-color: #f6f3f3;
  height: 100%;
}
.about-parallax-page section.sectionextra h2 {
  font-size: 50px !important;
  font-style: italic;
  font-weight: bold;
  color: #686f6f !important;
  color: #212427 !important;
  text-shadow: 2px 2px #ebebeb;
}
.about-parallax-page section.section-2 {
  height: 77vh;
  min-height: 480px;
}
.about-parallax-page section.section-2::before {
  background-color: #fff;
  height: 100%;
  filter: none;
}
.about-parallax-page section.section-3 {
  height: 100vh;
  padding: 10%;
  text-align: center;
}
.about-parallax-page section.section-3::before {
  background-image: url(/assets/images/002.jpg);
}
.about-parallax-page section.section-3 h5 {
  font-size: 30px;
  margin-bottom: 65px;
  font-weight: 600;
  color: #fff;
}
.about-parallax-page section.section-3 h6 {
  font-size: 20px;
  color: #212427 !important;
}
.about-parallax-page section.section-3 .card {
  background: rgba(255, 255, 255, 0.5882352941);
  min-height: 270px;
  transition: all 0.4s ease;
  cursor: pointer;
  border-radius: 10px;
  height: 100%;
}
.about-parallax-page section.section-3 .card .img-icon {
  margin-top: -57px;
  display: none;
}
.about-parallax-page section.section-3 .card .img-icon span {
  font-size: 50px;
  background: rgba(238, 238, 238, 0.4392156863);
  border-radius: 50%;
  width: 80px;
  display: inline-block;
}
.about-parallax-page section.section-3 .card:hover {
  background-color: rgba(23, 124, 195, 0.63);
}
.about-parallax-page section.section-3 .card:hover .card-text {
  color: #fff !important;
}
.about-parallax-page section.section-3 .card:hover .card-title {
  color: #fff !important;
}
.about-parallax-page section.section-4::before {
  background-image: url(/assets/images/001.jpg);
  background-image: none;
}
.about-parallax-page section.section-5::before {
  background-image: url(/assets/images/contact-bg.jpg);
}
.about-parallax-page section.section-5 .contact-form {
  width: 70%;
  margin: auto;
  background: 0;
  background: rgba(76, 71, 71, 0.4117647059);
  padding: 40px 6%;
  text-align: center;
  border-radius: 15px;
  color: #fff;
}
.about-parallax-page section.section-5 .contact-form h3 {
  font-size: 25px !important;
  color: #fff !important;
}
.about-parallax-page section.section-5 .contact-form .mat-form-field {
  display: block;
}
.about-parallax-page section.section-5 .contact-form .mat-form-field-label {
  color: #fff !important;
}
.about-parallax-page section.section-5 .contact-form button {
  font-size: 16px;
  width: 50%;
  border-radius: 20px;
  background-color: #5ea1d8;
  color: #fff;
  padding: 8px 15px;
  margin: 20px auto;
  display: block;
}
.about-parallax-page section.section-6 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.about-parallax-page section.section-6:before {
  content: "";
  background: url("/assets/images/004.jpg");
  background-size: cover;
  filter: blur(3px) brightness(0.3);
  height: 100%;
}
.about-parallax-page section.section-6 p {
  color: #fff !important;
  margin-bottom: 15px;
  font-size: 20px !important;
}
.about-parallax-page section.section-6 img {
  border-radius: 20px;
  max-width: 200px;
  margin-top: 20px;
}
.about-parallax-page section.section-7::before {
  min-height: auto;
}
.about-parallax-page .profile {
  position: fixed;
  display: inline-block;
  float: right;
  top: 96px;
  right: 82px;
  z-index: 1000;
  display: none;
}

.instan-ico img {
  height: 30px;
  width: 30px;
  position: fixed;
  display: inline-block;
  float: left;
  top: 92px;
  cursor: pointer;
  right: 25px;
  z-index: 1000;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .about-parallax-page .top-nav {
    max-width: 100% !important;
    justify-content: start !important;
  }
  .about-parallax-page .top-nav a {
    white-space: nowrap;
  }
  .about-parallax-page section .img-div-left,
  .about-parallax-page section .img-div-right {
    height: auto;
    width: 100%;
    margin-right: inherit;
    margin-left: inherit;
    max-height: 500px;
  }
  .about-parallax-page section.section-1 .pra-content h2.panel-right {
    font-size: 60px !important;
    line-height: 80px !important;
  }
  .about-parallax-page section.section-2 {
    height: auto;
  }
  .about-parallax-page section.section-3 {
    padding: 10% 15px;
    height: auto;
  }
  .about-parallax-page section.section-5 .contact-form {
    width: 80%;
  }
}
@media (max-width: 767px) {
  .mbotom {
    margin-bottom: 10px;
  }
  .about-parallax-page .top-nav {
    overflow: auto;
    flex-wrap: nowrap;
    max-width: 420px;
    max-width: 100%;
    justify-content: space-between;
  }
  .about-parallax-page .top-nav .step-section.nav-items {
    padding: 0;
  }
  .about-parallax-page .top-nav a {
    white-space: nowrap;
  }
  .about-parallax-page .profile {
    display: none;
  }
  .about-parallax-page section {
    position: relative;
    padding: 15px !important;
  }
  .about-parallax-page section::before {
    height: 100%;
  }
  .about-parallax-page section .img-div-left,
  .about-parallax-page section .img-div-right {
    height: auto;
    width: auto;
    margin-right: inherit;
  }
  .about-parallax-page section .panel-left,
  .about-parallax-page section .panel-right {
    padding: 15px !important;
  }
  .about-parallax-page section.section-1 {
    height: calc(100vh - 134px);
    padding: 0px 15px !important;
  }
  .about-parallax-page section.section-1 .pra-content h2 {
    font-size: 36px !important;
    line-height: 50px !important;
    padding: 0px !important;
  }
  .about-parallax-page section.section-2 {
    height: auto;
    min-height: auto;
  }
  .about-parallax-page section.sectionextra h2 {
    font-size: 36px !important;
  }
  .about-parallax-page section.section-3 {
    height: auto;
  }
  .about-parallax-page section.section-3 .card {
    min-height: auto;
    margin-bottom: 0px;
  }
  .about-parallax-page section.section-5 {
    padding: 50px 15px !important;
  }
  .about-parallax-page section.section-5 .contact-form {
    padding: 20px 15px;
    width: 100%;
  }
  .about-parallax-page section.section-5 .contact-form button {
    width: 80%;
  }
  .about-parallax-page section.section-6::before {
    height: 80vh;
  }
  .scroll-container {
    width: 100%;
  }
  .content-section {
    padding-top: 60px;
  }
  .about-parallax-page section.section-6:before {
    height: 100% !important;
  }
  .instan-ico img {
    height: 30px;
    width: 30px;
    position: fixed;
    display: inline-block;
    float: left;
    top: 146px;
    cursor: pointer;
    right: 10px;
    z-index: 1000;
  }
  .section-6 video {
    width: 100%;
  }
}
/* new design*/
.download {
  display: flex;
  align-items: center;
  justify-content: center;
}
.download img {
  margin: 10px 10px !important;
  border: 1px solid #fff !important;
  width: auto !important;
  height: 50px;
  border-radius: 5px !important;
  cursor: pointer;
}

/*code 2023*/
footer {
  display: flex;
  justify-content: center;
  height: 80px;
  align-items: center;
}

.cpyrgt {
  color: #212528 !important;
  list-style: none;
  padding: 0px;
  margin: 0px;
  height: 100%;
  display: flex;
  align-items: center;
}
.cpyrgt p {
  color: #212528 !important;
}

.f-menu-right {
  display: flex;
  list-style: none;
  padding: 0px;
  margin: 0px;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
}
.f-menu-right li {
  padding: 10px;
}
.f-menu-right li a {
  color: #212427 !important;
  font-size: 16px;
}

.container {
  display: flex;
  height: 100vh; /* Full screen height */
}

.action-panel {
  width: 10%; /* Takes 20% of the screen width */
  background-color: #f4f4f4;
  border-right: 1px solid #ddd;
  padding: 1rem;
  box-sizing: border-box;
}

.content-panel {
  width: 90%; /* Takes remaining 80% */
  background-color: #ffffff;
  padding: 1rem;
  box-sizing: border-box;
}

.action-panel {
  flex: 1;
}

.content-panel {
  flex: 4;
}

.action-panel {
  width: 20%;
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-right: 1px solid #ccc;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}

h3 {
  margin-top: 0;
  font-size: 1.2rem;
}

.control-group {
  margin-bottom: 1.5rem;
}

.control-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.control-group input,
.control-group select,
.control-group button {
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
}

button.primary {
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button.secondary {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  cursor: pointer;
}

input.form-control {
  font-size: 2rem; /* match your h2 style */
  font-weight: bold;
  border: none;
  border-bottom: 1px solid #ccc;
  width: 100%;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirm-dialog {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
  width: 300px;
  max-width: 80%;
  text-align: center;
}

.actions button {
  margin: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/create-about-us/create-about-us.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AACA;EACE,6BAAA;AAEF;;AACA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,YAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,WAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAEF;;AACA;EACE,mBAAA;EACA,0BAAA;AAEF;;AACA;EACE,mBAAA;EACA,0BAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,iCAAA;AAEF;AADE;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAGJ;AADE;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AAGJ;AADM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;AAGR;AAAQ;EACE,cAAA;EACA,wBAAA;AAEV;AAIE;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;AAHJ;AAII;EACE,0BAAA;AAFN;AAII;EACE,iBAAA;AAFN;AAII;EACE,kBAAA;AAFN;AAKI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AAHN;AAIM;EACE,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,uDAAA;EACA,2BAAA;AAFR;AAIM;EACE,qBAAA;EACA,oDAAA;AAFR;AAKI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AAHN;AAIM;EACE,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,uDAAA;EACA,2BAAA;AAFR;AAIM;EACE,qBAAA;EACA,oDAAA;AAFR;AAMI;EACE,WAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,iCAAA;AAJN;AAOI;EACE,2BAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AALN;AAMM;EACE,8CAAA;EACA,YAAA;EACA,QAAA;AAJR;AAMM;EACE,0BAAA;EACA,iBAAA;EACA,4DAAA;EACA,6BAAA;EACA,oCAAA;EACA,iBAAA;AAJR;AAQI;EACE,yBAAA;EACA,YAAA;AANN;AASM;EACE,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;AAPR;AAWI;EACE,YAAA;EACA,iBAAA;AATN;AAUM;EACE,sBAAA;EACA,YAAA;EACA,YAAA;AARR;AAYI;EACE,aAAA;EACA,YAAA;EAIA,kBAAA;AAbN;AAUM;EACE,6CAAA;AARR;AAWM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AATR;AAWM;EACE,eAAA;EACA,yBAAA;AATR;AAYM;EACE,6CAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAVR;AAWQ;EACE,iBAAA;EACA,aAAA;AATV;AAUU;EACE,eAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AARZ;AAWQ;EACE,0CAAA;AATV;AAUU;EACE,sBAAA;AARZ;AAUU;EACE,sBAAA;AARZ;AAeM;EACE,6CAAA;EACA,sBAAA;AAbR;AAkBM;EACE,oDAAA;AAhBR;AAkBM;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAhBR;AAiBQ;EACE,0BAAA;EACA,sBAAA;AAfV;AAiBQ;EACE,cAAA;AAfV;AAiBQ;EACE,sBAAA;AAfV;AAiBQ;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAfV;AAoBI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBN;AAmBM;EACE,WAAA;EACA,yCAAA;EACA,sBAAA;EACA,iCAAA;EACA,YAAA;AAjBR;AAoBM;EACE,sBAAA;EACA,mBAAA;EACA,0BAAA;AAlBR;AAoBM;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AAlBR;AAuBM;EACE,gBAAA;AArBR;AA2BE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;AAzBJ;;AA8BE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;AA3BJ;;AA+BA;EAEI;IACE,0BAAA;IACA,iCAAA;EA7BJ;EA8BI;IACE,mBAAA;EA5BN;EAgCI;;IAEE,YAAA;IACA,WAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EA9BN;EAkCQ;IACE,0BAAA;IACA,4BAAA;EAhCV;EAoCI;IACE,YAAA;EAlCN;EAqCI;IACE,iBAAA;IACA,YAAA;EAnCN;EAuCM;IACE,UAAA;EArCR;AACF;AA2CA;EACE;IACE,mBAAA;EAzCF;EA4CE;IACE,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,8BAAA;EA1CJ;EA2CI;IACE,UAAA;EAzCN;EA2CI;IACE,mBAAA;EAzCN;EA4CE;IACE,aAAA;EA1CJ;EA6CE;IACE,kBAAA;IACA,wBAAA;EA3CJ;EA4CI;IACE,YAAA;EA1CN;EA4CI;;IAEE,YAAA;IACA,WAAA;IACA,qBAAA;EA1CN;EA4CI;;IAEE,wBAAA;EA1CN;EA6CI;IACE,2BAAA;IACA,4BAAA;EA3CN;EA6CQ;IACE,0BAAA;IACA,4BAAA;IACA,uBAAA;EA3CV;EA+CI;IACE,YAAA;IACA,gBAAA;EA7CN;EAgDM;IACE,0BAAA;EA9CR;EAiDI;IACE,YAAA;EA/CN;EAgDM;IACE,gBAAA;IACA,kBAAA;EA9CR;EAiDI;IACE,6BAAA;EA/CN;EAgDM;IACE,kBAAA;IACA,WAAA;EA9CR;EA+CQ;IACE,UAAA;EA7CV;EAmDM;IACE,YAAA;EAjDR;EAsDA;IACE,WAAA;EApDF;EAsDA;IACE,iBAAA;EApDF;EAuDA;IACE,uBAAA;EArDF;EAwDE;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,qBAAA;IACA,WAAA;IACA,UAAA;IACA,eAAA;IACA,WAAA;IACA,aAAA;EAtDJ;EA2DE;IACE,WAAA;EAzDJ;AACF;AA6DA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA5DF;AA6DE;EACE,4BAAA;EACA,iCAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AA3DJ;;AA8DA,YAAA;AAKA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AA/DF;;AAiEA;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA9DF;AA+DE;EACE,yBAAA;AA7DJ;;AAgEA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AA7DF;AA8DE;EACE,aAAA;AA5DJ;AA6DI;EACE,yBAAA;EACA,eAAA;AA3DN;;AAgEA;EACE,aAAA;EACA,aAAA,EAAA,uBAAA;AA7DF;;AAgEA;EACE,UAAA,EAAA,kCAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;AA7DF;;AAgEA;EACE,UAAA,EAAA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AA7DF;;AA+DA;EACE,OAAA;AA5DF;;AA8DA;EACE,OAAA;AA3DF;;AA8DA;EACE,UAAA;EACA,yBAAA;EACA,eAAA;EACA,4BAAA;EACA,sBAAA;EACA,8BAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,iBAAA;AA3DF;;AA8DA;EACE,qBAAA;AA3DF;;AA8DA;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;AA3DF;;AA8DA;;;EAGE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,sBAAA;EACA,eAAA;AA3DF;;AA8DA;EACE,eAAA,EAAA,wBAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;AA3DF;;AA8DA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA3DF;;AA8DA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,uCAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AA3DF;;AA8DA;EACE,YAAA;AA3DF","sourcesContent":["body {\n  font-family: \"Raleway\" !important;\n  margin: 0;\n  padding: 0;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n}\n\n.activesection1 {\n  padding-top: 0px !important;\n}\n.activesection2 {\n  padding-top: 280px !important;\n}\n\n.main-container {\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.scroll-outer {\n  height: 100%;\n}\n\n.card-container {\n  height: 100%;\n  background: #2196f3;\n}\n\n.card-container h3 {\n  padding: 25px;\n}\n\n.scroll-container {\n  width: 100%;\n  width: calc(100% - 0px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 80px;\n  position: fixed;\n  top: 120px;\n  z-index: 1000;\n  background: #fff;\n}\n\n.scroll-container:hover {\n  opacity: 1;\n}\n\n.step-section {\n  display: flex;\n  flex-direction: row;\n  background-color: cream;\n  justify-content: flex-start;\n}\n\n.vertical-nav {\n  position: relative;\n}\n\n.step-section .circle {\n  background-color: white;\n  border: 4px solid red;\n  border-radius: 100%;\n  width: 12px;\n  height: 12px;\n  display: inline-block;\n}\n\n.step-section.completed .circle {\n  visibility: visible;\n  border-color: rgb(0, 0, 0);\n}\n\n.step-section.active .circle {\n  visibility: visible;\n  border-color: rgb(0, 0, 0);\n}\n\n.step-section.empty .circle {\n  visibility: hidden;\n}\n\n.about-parallax-page {\n  font-family: \"Raleway\" !important;\n  nav {\n    position: sticky;\n    top: 79px;\n    z-index: 10;\n    width: 100%;\n  }\n  .top-nav {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    height: 60px;\n    background: #fff;\n    list-style-type: none;\n    justify-content: center;\n    align-items: center;\n    .nav-items {\n      .nav-items-link {\n        color: #212427;\n        padding: 15px;\n        font-family: \"Raleway\";\n        font-size: 18px;\n        cursor: pointer;\n      }\n      &.active {\n        .nav-items-link {\n          color: #428bca;\n          border-bottom: 3px solid;\n        }\n      }\n    }\n  }\n\n  .inner-content {\n    z-index: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  section {\n    position: relative;\n    padding-bottom: 50px;\n    padding: 5% 10%;\n    p {\n      font-size: 16px !important;\n    }\n    p.panel-left {\n      padding-left: 15%;\n    }\n    p.panel-right {\n      padding-right: 15%;\n    }\n\n    .img-div-right {\n      height: 24vw;\n      width: 38vw;\n      margin-right: -10vw;\n      transition: all 0.8s linear;\n      img {\n        display: block;\n        object-fit: cover;\n        object-position: center;\n        height: 100%;\n        width: 100%;\n        box-shadow: 1px 4px 6px 0px #00000069;\n        transition: all 0.8s linear;\n      }\n      &:hover img {\n        transform: scale(1.1);\n        box-shadow: 8px 8px 19px #00000073;\n      }\n    }\n    .img-div-left {\n      height: 24vw;\n      width: 38vw;\n      margin-right: -10vw;\n      transition: all 0.8s linear;\n      img {\n        display: block;\n        object-fit: cover;\n        object-position: center;\n        height: 100%;\n        width: 100%;\n        box-shadow: 1px 4px 6px 0px #00000069;\n        transition: all 0.8s linear;\n      }\n      &:hover img {\n        transform: scale(1.1);\n        box-shadow: 8px 8px 19px #00000073;\n      }\n    }\n\n    &::before {\n      content: \"\";\n      background-repeat: no-repeat;\n      background-size: cover;\n      background-attachment: fixed;\n      width: 100%;\n      height: 100vh;\n      z-index: 1;\n      position: absolute;\n      left: 0%;\n      top: 0;\n      filter: blur(3px) brightness(0.4);\n    }\n\n    &.section-1 {\n      padding: 0px 10% !important;\n      display: flex;\n      width: 100%;\n      align-items: center;\n      justify-content: center;\n      height: 100vh;\n      height: 89vh;\n      &::before {\n        background-image: url(/assets/images/mob1.jpg);\n        height: 100%;\n        top: 0px;\n      }\n      .pra-content h2 {\n        font-size: 60px !important;\n        line-height: 93px;\n        background: -webkit-linear-gradient(#eee, rgb(25, 139, 173));\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n        font-weight: bold;\n      }\n    }\n\n    &.sectionextra {\n      background-color: #f6f3f3;\n      height: 100%;\n      // filter: none;\n\n      h2 {\n        font-size: 50px !important;\n        font-style: italic;\n        font-weight: bold;\n        color: #686f6f !important;\n        color: #212427 !important;\n        text-shadow: 2px 2px #ebebeb;\n      }\n    }\n\n    &.section-2 {\n      height: 77vh;\n      min-height: 480px;\n      &::before {\n        background-color: #fff;\n        height: 100%;\n        filter: none;\n      }\n    }\n\n    &.section-3 {\n      height: 100vh;\n      padding: 10%;\n      &::before {\n        background-image: url(/assets/images/002.jpg);\n      }\n      text-align: center;\n      h5 {\n        font-size: 30px;\n        margin-bottom: 65px;\n        font-weight: 600;\n        color: #fff;\n      }\n      h6 {\n        font-size: 20px;\n        color: #212427 !important;\n      }\n\n      .card {\n        background: #ffffff96;\n        min-height: 270px;\n        transition: all 0.4s ease;\n        cursor: pointer;\n        border-radius: 10px;\n        height: 100%;\n        .img-icon {\n          margin-top: -57px;\n          display: none;\n          span {\n            font-size: 50px;\n            background: #eeeeee70;\n            border-radius: 50%;\n            width: 80px;\n            display: inline-block;\n          }\n        }\n        &:hover {\n          background-color: rgba(23, 124, 195, 0.63);\n          .card-text {\n            color: #fff !important;\n          }\n          .card-title {\n            color: #fff !important;\n          }\n        }\n      }\n    }\n\n    &.section-4 {\n      &::before {\n        background-image: url(/assets/images/001.jpg);\n        background-image: none;\n      }\n    }\n\n    &.section-5 {\n      &::before {\n        background-image: url(/assets/images/contact-bg.jpg);\n      }\n      .contact-form {\n        width: 70%;\n        margin: auto;\n        background: 0;\n        background: #4c474769;\n        padding: 40px 6%;\n        text-align: center;\n        border-radius: 15px;\n        color: #fff;\n        h3 {\n          font-size: 25px !important;\n          color: #fff !important;\n        }\n        .mat-form-field {\n          display: block;\n        }\n        .mat-form-field-label {\n          color: #fff !important;\n        }\n        button {\n          font-size: 16px;\n          width: 50%;\n          border-radius: 20px;\n          background-color: #5ea1d8;\n          color: #fff;\n          padding: 8px 15px;\n          margin: 20px auto;\n          display: block;\n        }\n      }\n    }\n\n    &.section-6 {\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      &:before {\n        content: \"\";\n        background: url(\"/assets/images/004.jpg\");\n        background-size: cover;\n        filter: blur(3px) brightness(0.3);\n        height: 100%;\n      }\n\n      p {\n        color: #fff !important;\n        margin-bottom: 15px;\n        font-size: 20px !important;\n      }\n      img {\n        border-radius: 20px;\n        max-width: 200px;\n        margin-top: 20px;\n      }\n    }\n\n    &.section-7 {\n      &::before {\n        min-height: auto;\n        // background-color:yellow;\n      }\n    }\n  }\n\n  .profile {\n    position: fixed;\n    display: inline-block;\n    float: right;\n    top: 96px;\n    right: 82px;\n    z-index: 1000;\n    display: none;\n  }\n}\n\n.instan-ico {\n  img {\n    height: 30px;\n    width: 30px;\n    position: fixed;\n    display: inline-block;\n    float: left;\n    top: 92px;\n    cursor: pointer;\n    right: 25px;\n    z-index: 1000;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .about-parallax-page {\n    .top-nav {\n      max-width: 100% !important;\n      justify-content: start !important;\n      a {\n        white-space: nowrap;\n      }\n    }\n    section {\n      .img-div-left,\n      .img-div-right {\n        height: auto;\n        width: 100%;\n        margin-right: inherit;\n        margin-left: inherit;\n        max-height: 500px;\n      }\n      &.section-1 {\n        .pra-content {\n          h2.panel-right {\n            font-size: 60px !important;\n            line-height: 80px !important;\n          }\n        }\n      }\n      &.section-2 {\n        height: auto;\n      }\n\n      &.section-3 {\n        padding: 10% 15px;\n        height: auto;\n      }\n\n      &.section-5 {\n        .contact-form {\n          width: 80%;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .mbotom {\n    margin-bottom: 10px;\n  }\n  .about-parallax-page {\n    .top-nav {\n      overflow: auto;\n      flex-wrap: nowrap;\n      max-width: 420px;\n      max-width: 100%;\n      justify-content: space-between;\n      .step-section.nav-items {\n        padding: 0;\n      }\n      a {\n        white-space: nowrap;\n      }\n    }\n    .profile {\n      display: none;\n    }\n\n    section {\n      position: relative;\n      padding: 15px !important;\n      &::before {\n        height: 100%;\n      }\n      .img-div-left,\n      .img-div-right {\n        height: auto;\n        width: auto;\n        margin-right: inherit;\n      }\n      .panel-left,\n      .panel-right {\n        padding: 15px !important;\n      }\n\n      &.section-1 {\n        height: calc(100vh - 134px);\n        padding: 0px 15px !important;\n        .pra-content {\n          h2 {\n            font-size: 36px !important;\n            line-height: 50px !important;\n            padding: 0px !important;\n          }\n        }\n      }\n      &.section-2 {\n        height: auto;\n        min-height: auto;\n      }\n      &.sectionextra {\n        h2 {\n          font-size: 36px !important;\n        }\n      }\n      &.section-3 {\n        height: auto;\n        .card {\n          min-height: auto;\n          margin-bottom: 0px;\n        }\n      }\n      &.section-5 {\n        padding: 50px 15px !important;\n        .contact-form {\n          padding: 20px 15px;\n          width: 100%;\n          button {\n            width: 80%;\n          }\n        }\n      }\n\n      &.section-6 {\n        &::before {\n          height: 80vh;\n        }\n      }\n    }\n  }\n  .scroll-container {\n    width: 100%;\n  }\n  .content-section {\n    padding-top: 60px;\n  }\n\n  .about-parallax-page section.section-6:before {\n    height: 100% !important;\n  }\n  .instan-ico {\n    img {\n      height: 30px;\n      width: 30px;\n      position: fixed;\n      display: inline-block;\n      float: left;\n      top: 146px;\n      cursor: pointer;\n      right: 10px;\n      z-index: 1000;\n    }\n  }\n\n  .section-6 {\n    video {\n      width: 100%;\n    }\n  }\n}\n\n/* new design*/\n\n.download {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  img {\n    margin: 10px 10px !important;\n    border: 1px solid #fff !important;\n    width: auto !important;\n    height: 50px;\n    border-radius: 5px !important;\n    cursor: pointer;\n  }\n}\n/*code 2023*/\n\ntable {\n}\n\nfooter {\n  display: flex;\n  justify-content: center;\n  height: 80px;\n  align-items: center;\n}\n.cpyrgt {\n  color: #212528 !important;\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  p {\n    color: #212528 !important;\n  }\n}\n.f-menu-right {\n  display: flex;\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n  height: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  li {\n    padding: 10px;\n    a {\n      color: #212427 !important;\n      font-size: 16px;\n    }\n  }\n}\n\n.container {\n  display: flex;\n  height: 100vh; /* Full screen height */\n}\n\n.action-panel {\n  width: 10%; /* Takes 20% of the screen width */\n  background-color: #f4f4f4;\n  border-right: 1px solid #ddd;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.content-panel {\n  width: 90%; /* Takes remaining 80% */\n  background-color: #ffffff;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n.action-panel {\n  flex: 1;\n}\n.content-panel {\n  flex: 4;\n}\n\n.action-panel {\n  width: 20%;\n  background-color: #f9f9f9;\n  padding: 1.5rem;\n  border-right: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: Arial, sans-serif;\n}\n\nh3 {\n  margin-top: 0;\n  font-size: 1.2rem;\n}\n\n.control-group {\n  margin-bottom: 1.5rem;\n}\n\n.control-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n}\n\n.control-group input,\n.control-group select,\n.control-group button {\n  width: 100%;\n  padding: 0.5rem;\n  margin-bottom: 0.5rem;\n  box-sizing: border-box;\n}\n\nbutton.primary {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\nbutton.secondary {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  cursor: pointer;\n}\n\ninput.form-control {\n  font-size: 2rem; /* match your h2 style */\n  font-weight: bold;\n  border: none;\n  border-bottom: 1px solid #ccc;\n  width: 100%;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.confirm-dialog {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);\n  width: 300px;\n  max-width: 80%;\n  text-align: center;\n}\n\n.actions button {\n  margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
